var _circle, _circle2, _path, _path2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    id: "Vrstva_1",
    "data-name": "Vrstva 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.22 41.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.36,
    cy: 20.84,
    r: 0.92
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.76,
    cy: 20.84,
    r: 0.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.35,17.2c-2.07,0-1.39,1.24-5.76,1.24S22.9,17.2,20.83,17.2a3.66,3.66,0,0,0,0,7.31c2.07,0,1.39-1.25,5.76-1.25s3.69,1.25,5.76,1.25a3.66,3.66,0,0,0,0-7.31ZM20.76,22.29a1.45,1.45,0,1,1,1.45-1.45A1.44,1.44,0,0,1,20.76,22.29Zm11.6,0a1.45,1.45,0,1,1,1.45-1.45A1.44,1.44,0,0,1,32.36,22.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.21,4.29a.93.93,0,0,0,0-1.31.92.92,0,0,0-1.3,0,.93.93,0,0,0,0,1.31A.92.92,0,0,0,50.21,4.29Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.36,
    cy: 11.84,
    r: 0.92
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44,14.38c1.46-1.46.1-1.86,3.2-5s3.49-1.73,4.95-3.19A3.66,3.66,0,0,0,47,1.07c-1.46,1.46-.1,1.86-3.19,4.95S40.3,7.75,38.84,9.21A3.65,3.65,0,1,0,44,14.38ZM48.54,2.61a1.45,1.45,0,1,1,0,2.05A1.46,1.46,0,0,1,48.54,2.61Zm-8.2,10.25a1.45,1.45,0,1,1,2,0A1.44,1.44,0,0,1,40.34,12.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.73,16.26A3.83,3.83,0,0,1,37,12.49a11.66,11.66,0,0,1-1.75,2.11h0a11.66,11.66,0,0,1-2.11,1.75,3.76,3.76,0,0,1,2.65,1.12,3.81,3.81,0,0,1,1.12,2.65A11.24,11.24,0,0,1,38.59,18h0A11.66,11.66,0,0,1,40.73,16.26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.15,29.18a.92.92,0,1,0,1.3,0A.92.92,0,0,0,11.15,29.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94,37.38a.92.92,0,0,0,1.31,1.3.92.92,0,0,0,0-1.3A.93.93,0,0,0,2.94,37.38Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21,27.26C7.75,28.72,9.12,29.12,6,32.21S2.53,34,1.07,35.41a3.65,3.65,0,0,0,5.17,5.16c1.46-1.46.1-1.85,3.19-5s3.49-1.73,5-3.19a3.66,3.66,0,1,0-5.17-5.17ZM4.62,39.05a1.45,1.45,0,1,1,0-2A1.44,1.44,0,0,1,4.62,39.05Zm8.2-8.2a1.45,1.45,0,1,1,0-2.05A1.44,1.44,0,0,1,12.82,30.85Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.15,25.27a3.85,3.85,0,0,1-2.65-1.12,3.78,3.78,0,0,1-1.12-2.65,12,12,0,0,1-1.75,2.11h0a10.85,10.85,0,0,1-2.11,1.75,3.85,3.85,0,0,1,2.65,1.12,3.76,3.76,0,0,1,1.12,2.65A12,12,0,0,1,18,27h0A11.1,11.1,0,0,1,20.15,25.27Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.53b11d04d95b17974976f4f9754680fe.svg";
export { ForwardRef as ReactComponent };